import { Component, OnInit, ViewChild } from '@angular/core';
import { InternalUser, ExternalUser, Roles, Agency } from '@adminmodel/admin';
import { SelectItem } from 'primeng/api';
import { AdminService } from '@adminservice/admin.service';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { forEach } from '@angular/router/src/utils/collection';
import { ValueTransformer } from '@angular/compiler/src/util';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { HttpClient } from '@angular/common/http';
import { Angular2Csv } from 'angular2-csv/Angular2-csv';
import { authManager } from '@authmanager/authManager';
import { Table } from 'primeng/table';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css'],
  providers: [AdminService, ConfirmationService]
})
export class AdminComponent implements OnInit {

  @ViewChild('dtInternal') private _internalUsersTable: Table;

  @ViewChild('dtExternal') private _externalUsersTable: Table;
  userDetails: any = [];
  disableExUploadBtn: boolean;
  currentSSO: any;
  currentEmail: any;
  currentExEmail: any;
  isExEmailExist: boolean;
  isInEmailExist: boolean;
  invalidSSO: boolean;
  invalidFileFormat: boolean;
  saveMsg: boolean;
  invalidExEditAgency: boolean;
  invalidInEditEmail: boolean;
  invalidExEditEmail: boolean;
  invalidExEditFirstName: boolean;
  invalidInEditFirstName: boolean;
  invalidInEditLastName: boolean;
  invalidExEditLastName: boolean;
  invalidSSOAddNewIn: boolean;
  duplicateSSOEditIN: boolean;
  duplicateEmailEditIN: boolean;
  duplicateEmailEditEx: boolean;
  msgs: any = [];
  ExMsgs: any = [];
  ssoMsg: any = [];
  emailMsg: any = [];
  firstNameMsg: any = [];
  lastNameMsg: any = [];
  agencyMsg: any = [];
  roleMsg: any = [];
  ValidateExFirstName: boolean;
  ValidateExLastName: boolean;
  ValidateExEmail: boolean;
  ValidateExAgency: boolean;
  validateSSO: boolean;
  ValidateFirstName: boolean;
  ValidateEmail: boolean;
  ValidateLastName: boolean;
  ValidateAgency: boolean;
  ValidateRole: boolean;
  duplicateSSO: boolean;  // set if the SSO is dupliacted
  disableSubmitbtn: boolean; // set if the SSO is dupliacted

  internalUser: any = [];
  externalUser: any[] = [];

  LogUserDetails: any = [];
  UserLogStatus: any = [];

  updatedINDetails: any = {};
  updatedExDetails: any = {};

  deletedINuserDetails: any = {};


  externalUserType: string;
  internalUserType: string;
  IsActive: number;

  selectedInternalUser;
  selectedExternalUsers;

  ShowInternalUser: boolean;
  ShowExternalUser: boolean;

  saveRow: boolean;
  cancelRow: boolean;

  saveExternalRow: boolean;
  cancelExternalRow: boolean;

  showAddInternalUserRow: boolean;
  showAddExternalUserRow: boolean;

  showSubmitbtn: boolean;
  userRoles: Roles[];
  selectedRole: Roles;
  agency: Agency[];
  agencyFilter: any[];
  selectedInAgency: Agency;
  selectedExAgency: Agency;
  emailPattern: any;
  internalEmailPattern: string;
  namePattern: any;
  ssoPattern: any;


  beforIN: any = {};
  beforINEdit: any = {};
  beforEx: any = {};
  beforExEdit: any = {};
  postStatus: any;
  SSOresult: any;
  SSOduplicateStatus: any;
  INduplicateEmailonEdit: any;
  ExduplicateEmailonEditStatus: any;

  disableINeditBtn: boolean;
  disableINdeleteBtn: boolean;
  disableExEditBtn: boolean;
  disableExDeleteBtn: boolean;
  disableINUpdateBtn: boolean;
  disableExUpdateBtn: boolean;

  displayBulkUploadPopUp: boolean;
  fname: any;
  value: any;
  jsonFile: any;
  temp: any;
  BulkData: any = {};
  fileDataError: boolean;

  public newInternalUser: any = {};
  public newRole: any = {};
  public newAgency: any = {};
  public newExAgency: any = {};
  public newExtenalUser: any = {};

  LognewUser: any = {};
  UserLog: string;
  require: any;
  LnewUser: any = {};
  isAddInternal: boolean;
// Arvind Add Agency
  isAddAgency: boolean;
//End Arvind Add Agency
  // filters
  enableInternalUsersFilter: boolean;
  enableExternalUsersFilter: boolean;

  hideinternal: boolean;
  bulkUploadEmailPattern: any;
  invalidData: boolean;
  MultiAgencyExist: boolean;
  AddMultiAgencyExist: boolean;
  duplicateExternalAgency: string;
  MultipleAgeccyID: string;
  UserId: string;

  public paddingCells: any = {
    background: '#ff0000',
    textAlign: 'center'
  };


  constructor(private adminService: AdminService, private confirmationService: ConfirmationService,
    private http: HttpClient, private AuthManager: authManager, private router: Router) {
    this.invalidFileFormat = true;
    this.saveMsg = true;
    this.disableExUploadBtn = false;
    this.isExEmailExist = true;
    this.isInEmailExist = true;
    this.validateSSO = true;
    this.ValidateFirstName = true;
    this.ValidateEmail = true;
    this.ValidateLastName = true;
    this.ValidateAgency = true;
    this.ValidateRole = true;
    this.validateSSO = true;
    this.invalidSSO = true;
    this.invalidSSOAddNewIn = true;
    this.duplicateSSOEditIN = true;
    this.duplicateEmailEditIN = true;
    this.duplicateEmailEditEx = true;
    this.invalidInEditEmail = true;
    this.invalidInEditFirstName = true;
    this.invalidInEditLastName = true;
    this.invalidExEditEmail = true;
    this.invalidExEditAgency = true;
    this.invalidExEditFirstName = true;
    this.invalidExEditLastName = true;
    this.duplicateSSO = true;
    this.disableSubmitbtn = false;
    this.ValidateExFirstName = true;
    this.ValidateExLastName = true;
    this.ValidateExEmail = true;
    this.ValidateExAgency = true;

    this.externalUserType = 'E';
    this.internalUserType = 'I';
    this.IsActive = 1;
    this.saveRow = false;
    this.cancelRow = false;
    this.saveExternalRow = false;
    this.cancelExternalRow = false;

    this.showAddInternalUserRow = false;
    this.showAddExternalUserRow = false;
    this.showSubmitbtn = false;

    this.disableINeditBtn = false;
    this.disableINdeleteBtn = false;
    this.disableExEditBtn = false;
    this.disableExDeleteBtn = false;
    this.disableINUpdateBtn = false;
    this.disableExUpdateBtn = false;
    this.fileDataError = false;
    this.enableInternalUsersFilter = false;
    this.enableExternalUsersFilter = false;
    this.hideinternal = false;
    this.invalidData = false;
    this.MultiAgencyExist = false;
    this.AddMultiAgencyExist = false;

    this.displayBulkUploadPopUp = false;

    // this.emailPattern = '^[A-Za-z0-9._%+-]{2,}@[a-zA-Z0-9]{1,}([.]{1}[a-zA-Z]{2,}|[.]{1}[a-zA-Z]{2,}[.]{1}[a-zA-Z]{2,})$';
    // fix for email id special caracter.
    this.emailPattern = '^[A-Za-z0-9._%+-]{1,}@[a-zA-Z0-9_ -]{2,}([.]{1}[a-zA-Z]{2,}|[.]{1}[a-zA-Z]{2,}[.]{1}[a-zA-Z]{2,})$';
    
    this.internalEmailPattern = '^[A-Za-z0-9._%+-]{2,}@[nN][bB][cC][uU][nN][iI].[cC][oO][mM]$';

    this.bulkUploadEmailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    this.namePattern = '^[a-zA-Z ]+$';
    this.ssoPattern = '^((?!(0))[0-9]{9})$';

    // Service call to get the user roles

    this.adminService.getUserRoles().subscribe(
      p => this.userRoles = p,
    );
    // Service call to get the Agency List
    this.adminService.getAgencyList()
      .subscribe(resAgencyData => this.agency = resAgencyData);

  }

  ngOnInit() {
    this.MultiAgencyExist = false;
    if (Number(this.AuthManager.dynSSOId) > 0 && Number(sessionStorage.getItem('userid')) > 0) {
      this.saveIP();
    }   // Method to store logged in user information
    if (sessionStorage.getItem('userRoleId') === '2') {
      this.hideinternal = true; // hiding the refund tab for admin
      let divToChange = document.getElementById('id2');
      divToChange.className = 'active';
      let oneA = document.getElementById('1a');
      oneA.className = 'tab-pane';
      let twoA = document.getElementById('2a');
      twoA.className = 'tab-pane active';
      this.ShowInternalUser = false;
      this.ShowExternalUser = true;
      this.LoadExternalUsers();

    } else {
      this.hideinternal = false;
      let divToChange = document.getElementById('id1');
      divToChange.className = 'active';

      let oneA = document.getElementById('1a');
      oneA.className = 'tab-pane active';

      let twoA = document.getElementById('2a');
      twoA.className = 'tab-pane';

      this.ShowInternalUser = true;
      this.ShowExternalUser = false;
      this.isAddInternal = false;

      // Arvind Add Agency
      this.isAddAgency = false;
       //End Arvind Add Agency
      this.LoadInternalUsers();
      this.LoadExternalUsers();
    }
  }
  // service call to get the Internal User details
  LoadInternalUsers() {

    this.adminService.getInternalUsers().subscribe(
      p => { this.internalUser = p; }
    );
    //console.log(this.internalUser);
  }
  // service call to get the External User Details
  LoadExternalUsers() {
    this.adminService.getExternalUsers()
      .subscribe(resExternalUserData => this.externalUser = resExternalUserData);
    //console.log(this.externalUser);
    //console.log(this.selectedExAgency);
  }
  // Methods to switch between Internal User and External User Tab Starts
  showInternalUser(dtExternal, ExternalUserTableSearch) {

    // To clear the external users global filter
    dtExternal.reset();
    ExternalUserTableSearch.value = '';

    this.ShowInternalUser = true;
    this.ShowExternalUser = false;
    this.showAddExternalUserRow = false;
    this.ValidateExFirstName = true;
    this.ValidateExLastName = true;
    this.ValidateExEmail = true;
    this.ValidateExAgency = true;
  }
  showExternalUser(dtInternal, InternalUserTableSearch) {

    // To clear the internal users global filter
    dtInternal.reset();
    InternalUserTableSearch.value = '';

    this.ShowExternalUser = true;
    this.ShowInternalUser = false;
    this.showAddInternalUserRow = false;
    this.validateSSO = true;
    this.invalidSSOAddNewIn = true;
    this.invalidSSO = true;
    this.ValidateAgency = true;
    this.ValidateFirstName = true;
    this.ValidateLastName = true;
    this.ValidateRole = true;
    this.duplicateSSO = true;
    this.ValidateEmail = true;
  }
  // Ends

  // Method to show Add Internal User Form
  showAddInternalUserArea() {
    // debugger;
    this.isAddInternal = false;
    this.showAddInternalUserRow = true;
    for (let item of this.internalUser) {
      if (item.isEditable) {
        item.isEditable = false;
        this.disableINeditBtn = false;
        this.disableINdeleteBtn = false;
      }
    }
  }
  // Method to show Add External User form
  showAddExternalUserArea() {

    this.showAddExternalUserRow = true;
    for (let item of this.externalUser) {
      if (item.isEditable) {
        item.isEditable = false;
        this.disableExEditBtn = false;
        this.disableExDeleteBtn = false;
      }
    }

  }
  // Method to close the Add Internal User Row
  showAddInternalUserRowClose() {
    this.isAddInternal = false;

    this.isInEmailExist = true;
    this.showAddInternalUserRow = false;
    this.validateSSO = true;
    this.invalidSSOAddNewIn = true;
    this.ValidateEmail = true;
    this.ValidateFirstName = true;
    this.ValidateLastName = true;
    this.ValidateAgency = true;
    this.ValidateRole = true;
    this.duplicateSSO = true;
  }
  // Method to close the Add External User Row
  showAddExternalUserRowClose() {

    this.isExEmailExist = true;
    this.showAddExternalUserRow = false;
    this.ValidateExFirstName = true;
    this.ValidateExLastName = true;
    this.ValidateExEmail = true;
    this.ValidateExAgency = true;
  }

  // Internal - Edit row code starts here
  onRowEditSelect(event, myForm) {

    this.showAddInternalUserRow = false; // hiding the add new IN user on edit
    // hiding all the validation messages of add new IN users.
    this.invalidSSOAddNewIn = true;
    this.duplicateSSO = true;
    this.validateSSO = true;
    this.ValidateFirstName = true;
    this.ValidateLastName = true;
    this.ValidateEmail = true;
    this.isInEmailExist = true;
    this.ValidateRole = true;
    this.restForm(myForm);

    this.currentSSO = event.sso;
    this.currentEmail = event.email;
    this.selectedRole = event.roles;
    this.selectedInAgency = event.agency;
    this.beforIN = JSON.parse(JSON.stringify(event));
    this.beforINEdit = JSON.parse(JSON.stringify(this.internalUser)); // storing current IN user
    this.disableINeditBtn = true; // disable  the edit btn on click
    this.disableINdeleteBtn = true;
    //console.log(event);
    this.CloseAllEditable();
    event.isEditable = true;
    if (event.isEditable === true) {
      this.saveRow = true;
      this.cancelRow = true;
    }
  }
  CloseAllEditable() {

    for (let item of this.internalUser) {
      if (item.isEditable) {
        item.isEditable = false;
      }
    }
  }
  internalUsersFilterToggle(event) {

    this.enableInternalUsersFilter === false ? this.enableInternalUsersFilter = true : this.enableInternalUsersFilter = false;

    if (!this.enableInternalUsersFilter) {
      this._internalUsersTable.reset();
    }

  }

  externalUsersFilterToggle(event) {

    this.enableExternalUsersFilter === false ? this.enableExternalUsersFilter = true : this.enableExternalUsersFilter = false;
    if (!this.enableExternalUsersFilter) {
      this._externalUsersTable.reset();
    }
  }
  onCancelRowClick(row) {
    this.internalUser = this.beforINEdit;
    this.disableINeditBtn = false; // enable  the edit btn on cancel click
    this.disableINdeleteBtn = false; // enable the delete button on cancel click
    this.disableINUpdateBtn = false; // enable  the update btn on cancel click
    this.msgs = [];
    this.invalidSSO = true;
    this.duplicateSSOEditIN = true;
    this.duplicateEmailEditIN = true;
    this.invalidInEditEmail = true;
    this.invalidInEditFirstName = true;
    this.invalidInEditLastName = true;
    row.isEditable = false;
    this.saveRow = false;
    this.cancelRow = false;

  }
  // Internal - Edit row code ends here

  onRowExternalEditSelect(event, myExternalUserForm) {

    //console.log(event);

    this.showAddExternalUserRow = false; // hiding the add new Ex user on edit
    // hiding all the validation messages of add new Ex users.
    this.ValidateExFirstName = true;
    this.ValidateExLastName = true;
    this.isExEmailExist = true;
    this.ValidateExEmail = true;
    this.ValidateExAgency = true;
    this.restForm(myExternalUserForm);

    this.currentExEmail = event.email;
    this.selectedExAgency = event.agency;
    this.beforEx = JSON.parse(JSON.stringify(event));
    this.beforExEdit = JSON.parse(JSON.stringify(this.externalUser)); // storing current IN user
    this.disableExEditBtn = true; // disable  the edit btn on click
    this.disableExDeleteBtn = true; // disable  the delete btn on click
    this.CloseAllExternalEditable();
    event.isEditable = true;
    if (event.isEditable === true) {
      this.saveExternalRow = true;
      this.cancelExternalRow = true;
    }
  }
  CloseAllExternalEditable() {

    for (let item of this.externalUser) {
      if (item.isEditable) {
        item.isEditable = false;
      }
    }
  }
  onCancelExternalRowClick(row) {

    this.externalUser = this.beforExEdit;
    this.disableExEditBtn = false; // enable  the edit btn on cancel click
    this.disableExUpdateBtn = false; // enable  the update btn on cancel click
    this.disableExDeleteBtn = false; // enable  the delete btn on cancel click
    this.ExMsgs = [];
    row.isEditable = false;
    this.saveExternalRow = false;
    this.invalidExEditEmail = true;
    this.invalidExEditFirstName = true;
    this.invalidExEditLastName = true;
    this.duplicateEmailEditEx = true;
    this.invalidExEditAgency = true;
    this.cancelExternalRow = false;
    this.MultiAgencyExist = false;

  }
  // Method for External user - Bulk upload
  onBulkUploadClick() {
    this.resetBulkUpload();
    this.displayBulkUploadPopUp = true;
    this.saveMsg = true;

  }
  onExternalUserBulkUpload() {

    this.BulkData = this.jsonFile;
    this.saveMsg = true;
    if (this.BulkData == null) {
      this.invalidFileFormat = false;
    } else {
      // this.BulkData = eval(this.BulkData);
      for (let item in this.BulkData) {
        if (this.BulkData.hasOwnProperty(item)) {
          this.BulkData[item].Usertype = this.externalUserType;
          this.BulkData[item].IsActive = this.IsActive;
          this.BulkData[item].CreatedDate = new Date();
          this.BulkData[item].CreatedBy = this.AuthManager.dynSSOId;
          this.BulkData[item].UserAgencyID = this.BulkData[item].UserAgencyID;
        }
      }
      this.adminService.AddMultipleExternalUsers(this.BulkData)
        .subscribe((status) => {
          this.postStatus = status;

          this.saveMsg = false;
          this.LoadExternalUsers();
          this.jsonFile = null;
        });
    }
  }



  openFile(event) {

    if (event.target.files !== 0 && event.target.files.length > 0) {
      if (event.target.files[0].type === 'application/vnd.ms-excel') {
        this.invalidFileFormat = true;
        this.disableExUploadBtn = false;

        let input = event.target;
        for (let index = 0; index < input.files.length; index++) {
          let reader = new FileReader();
          let file = event.target.files[0];
          this.fname = file.name;
          reader.onload = () => {
            // this 'value' is the content of the file

            this.value = reader.result;


            this.jsonFile = this.csvJSON(this.value);

            this.jsonFile = JSON.parse(this.jsonFile);
          };
          reader.readAsText(input.files[index]);
        }
      } else {
        this.ErrorInBulkUpload('invalidFormat');
      }
    }

  }

  ErrorInBulkUpload(param) {
    if (param === 'invalidData') {
      this.invalidData = true;
    }
    if (param === 'invalidFormat') {
      this.invalidFileFormat = false;
    }
    if (param === 'fileDataError') {
      this.fileDataError = true;
    }

    this.disableExUploadBtn = true;
  }

  resetBulkUpload() {
    this.jsonFile = null;
    this.invalidData = false;
    this.invalidFileFormat = true;
    this.fileDataError = false;
    this.disableExUploadBtn = false;
    this.saveMsg = true;
  }

  // method to convert csv data into JSON
  csvJSON(event) {

    let lines = event.split('\n');
    if (lines.length <= 2) {
      this.ErrorInBulkUpload('fileDataError');
    }

    let result = [];
    let headers = lines[0].split(',');
    headers = headers.map(function (e) { return e.trim(); });
    let headersValue = ['FirstName', 'LastName', 'EmailID', 'UserAgencyID'];

    let a = headersValue.toString().trim();
    let b = headers.toString().trim();
    if (a !== b) {
      this.ErrorInBulkUpload('fileDataError');
      return;
    }
    for (let i = 1; i < lines.length - 1; i++) {

      let obj = {};
      let currentline = lines[i].split(',');
      currentline = currentline.map(function (e) { return e.trim(); });
      for (let j = 0; j < headers.length; j++) {

        if (j === 3) {
          obj['UserAgencyID'] = currentline[j];
        } else {
          obj[headers[j]] = currentline[j];
        }

        if (currentline[j] === null || currentline[j] === '') {
          this.ErrorInBulkUpload('invalidData');
          return;
        }
        // email validation
        if (j === 2) {

          if (this.bulkUploadEmailPattern.test(currentline[j]) === false) {
            this.ErrorInBulkUpload('invalidData');
            return;
          }
        }

      }
      result.push(obj);
    }

    return JSON.stringify(result); // JSON
  }
  // Methods for External user data submission - for SSO
  onExternalUserRowSelect(SelctedExUsers) {

    if (SelctedExUsers.length > 0) {
      this.showSubmitbtn = true;
    } else {
      this.showSubmitbtn = false;
    }
  }
  onExternalUserRowUnSelect(SelctedExUsers) {

    if (SelctedExUsers.length > 0) {
      this.showSubmitbtn = true;
    } else {
      this.showSubmitbtn = false;
    }
  }
  HeaderCheckBoxToggle(SelctedExUsers) {
    if (SelctedExUsers.length > 0) {
      this.showSubmitbtn = true;
    } else {
      this.showSubmitbtn = false;
    }
  }
  // Method to call IDM API for SSO creation
  externalUserSSOTrigger(data) {

    this.selectedExternalUsers = data;
  }
  // Method to check dulpicate SSO
  checkDuplicateSSO(ssoID, myForm) {

    this.adminService.internalUserSearch(ssoID)
      .subscribe((status) => {
        this.SSOresult = status;
        //console.log(this.SSOresult);

        if (this.SSOresult === 'F') {
          this.duplicateSSO = false;
          this.validateSSO = true;
        }
        if (this.SSOresult === 'P') {
          this.duplicateSSO = true;

          if (ssoID !== 0 && myForm.valid) {

            this.ValidateRole = true;
            this.ValidateEmail = true;

            this.newInternalUser.Usertype = this.internalUserType;
            this.newInternalUser.UserRoleID = this.newInternalUser.newRole.roleID;

            if (this.newInternalUser.hasOwnProperty('newAgency') && this.newInternalUser.newAgency != null) {
              this.newInternalUser.UserAgencyID = this.newInternalUser.newAgency.agencyID;
            } else {
              this.newInternalUser.UserAgencyID = '';
            }


            if (myForm.controls.firstName.value !== '' && myForm.controls.lastName.value !== '') {
              if (myForm.controls.firstName.value.trim().length > 0 && myForm.controls.lastName.value.trim().length > 0) {
                this.ValidateFirstName = true;
                this.ValidateLastName = true;

                this.newInternalUser.IsActive = this.IsActive;
                this.addNewUser(this.newInternalUser, myForm);

              } else {
                if (myForm.controls.firstName.value.trim().length === 0) {
                  this.ValidateFirstName = false;
                }
                if (myForm.controls.lastName.value.trim().length === 0) {
                  this.ValidateLastName = false;
                }
              }
            }
            if (myForm.controls.firstName.value !== '' || myForm.controls.lastName.value !== '') {
              if (myForm.controls.firstName.value.trim().length === 0) {
                this.ValidateFirstName = false;
              }
              if (myForm.controls.lastName.value.trim().length === 0) {
                this.ValidateLastName = false;
              }
            }

          } else {
            // Validation for first name
            if (!myForm.controls.firstName.valid) {
              this.ValidateFirstName = false;
              if (myForm.controls.firstName.value != null) {
                if (myForm.controls.firstName.value.trim().length === 0) {
                  this.ValidateFirstName = false;
                }
              }
            }
            if (myForm.controls.firstName.valid) {
              if (myForm.controls.firstName.value.trim().length > 0) {
                this.ValidateFirstName = true;
              } else {
                this.ValidateFirstName = false;
              }
            }
            // Validation for SSO
            if (!myForm.controls.sso.valid) {
              this.validateSSO = false;
            }
            if (myForm.controls.sso.valid) {
              this.validateSSO = true;
              if (ssoID === 0) {
                this.invalidSSOAddNewIn = false;
              } else if (ssoID !== 0) {
                this.invalidSSOAddNewIn = true;
              }
            }
            // Validation for email
            if (!myForm.controls.email.valid) {
              //debugger;
              this.ValidateEmail = false;
              this.isInEmailExist = true;
            }
            if (myForm.controls.email.valid) {
             // debugger;
              this.ValidateEmail = true;
            }
            // Validation for last name
            if (!myForm.controls.lastName.valid) {
              this.ValidateLastName = false;
              if (myForm.controls.lastName.value != null) {
                if (myForm.controls.lastName.value.trim().length === 0) {
                  this.ValidateLastName = false;
                }
              }
            }
            if (myForm.controls.lastName.valid) {
              if (myForm.controls.lastName.value.trim().length > 0) {
                this.ValidateLastName = true;
              } else {
                this.ValidateLastName = false;
              }
            }
            // Validation for agency
            if (!myForm.controls.agency.valid) {
              this.ValidateAgency = false;
            }
            if (myForm.controls.agency.valid) {
              this.ValidateAgency = true;
            }
            // Validation for role
            if (!myForm.controls.userRoles.valid) {
              this.ValidateRole = false;
            }
            if (myForm.controls.userRoles.valid) {
              this.ValidateRole = true;
            }
          }

        }
      });

  }
  // Method to add new internal Users
  onAddNewInternalUserSubmit(myForm) {

    let ssoID = myForm.controls.sso.value;
    this.checkDuplicateSSO(ssoID, myForm);

  }
  // Method to reset the Add Internal/External form controls
  restForm(formData) {

    for (let name in formData.controls) {
      if (formData.controls.hasOwnProperty(name)) {
        formData.controls[name].reset();
      }
    }
  }
  // Method to add new External Users
  onAddNewExternalUserSubmit(myExternalUserForm) {
//debugger;
    if (myExternalUserForm.valid) {


      this.ValidateExAgency = true;
      this.ValidateExEmail = true;
      if (myExternalUserForm.controls.firstName.value !== '' && myExternalUserForm.controls.lastName.value !== '') {
        if (myExternalUserForm.controls.firstName.value.trim().length > 0 && myExternalUserForm.controls.lastName.value.trim().length > 0) {
          this.ValidateExFirstName = true;
          this.ValidateExLastName = true;

          this.newExtenalUser.Usertype = this.externalUserType;
          this.newExtenalUser.UserAgencyID = this.newExtenalUser.newExAgency.agencyID;
          this.newExtenalUser.IsActive = this.IsActive;
          this.addNewUser(this.newExtenalUser, myExternalUserForm);

        } else {
          if (myExternalUserForm.controls.firstName.value.trim().length === 0) {
            this.ValidateExFirstName = false;
          }
          if (myExternalUserForm.controls.lastName.value.trim().length === 0) {
            this.ValidateExLastName = false;
          }
        }
      }
      if (myExternalUserForm.controls.firstName.value !== '' || myExternalUserForm.controls.lastName.value !== '') {
        if (myExternalUserForm.controls.firstName.value.trim().length === 0) {
          this.ValidateExFirstName = false;
        }
        if (myExternalUserForm.controls.lastName.value.trim().length === 0) {
          this.ValidateExLastName = false;
        }
      }
    } else {
      // validation for first name
      if (!myExternalUserForm.controls.firstName.valid) {
        this.ValidateExFirstName = false;
      }
      if (myExternalUserForm.controls.firstName.valid) {
        if (myExternalUserForm.controls.firstName.value != null) {
          if (myExternalUserForm.controls.firstName.value.trim().length > 0) {
            this.ValidateExFirstName = true;
          }
        } else {
          this.ValidateExFirstName = false;
        }
      }
      // Validation for last name
      if (!myExternalUserForm.controls.lastName.valid) {
        this.ValidateExLastName = false;
      }
      if (myExternalUserForm.controls.lastName.valid) {
        if (myExternalUserForm.controls.lastName.value != null) {
          if (myExternalUserForm.controls.lastName.value.trim().length > 0) {
            this.ValidateExLastName = true;
          }
        } else {
          this.ValidateExLastName = false;
        }
      }
      // Validation for email id
      if (!myExternalUserForm.controls.email.valid) {
        this.ValidateExEmail = false;
        this.isExEmailExist = true;
      }
      if (myExternalUserForm.controls.email.valid) {
        //this.isExEmailExist = false;
        this.ValidateExEmail = true;


      }
      // Validation for agency
      if (!myExternalUserForm.controls.agency.valid) {
        this.ValidateExAgency = false;
      }
      if (myExternalUserForm.controls.agency.valid) {
        this.ValidateExAgency = true;

      }
    }
  }
  // Method to add new Internal/External Users
  addNewUser(newUser: any = {}, myform) {

    newUser.CreatedDate = new Date();
    newUser.CreatedBy = this.AuthManager.dynSSOId;
    this.adminService.postNewUserDetails(newUser)
      .subscribe((status) => {
        this.postStatus = status;

        if (newUser.Usertype === this.internalUserType) {

          if (this.postStatus === 'P') {
            this.LoadInternalUsers();
            this.newInternalUser = {};
            this.showAddInternalUserRow = false;
            this.restForm(myform);

            this.validateSSO = true;
            this.invalidSSOAddNewIn = true;
            this.ValidateAgency = true;
            this.ValidateFirstName = true;
            this.ValidateLastName = true;
            this.ValidateRole = true;
            this.duplicateSSO = true;
            this.isInEmailExist = true;
          } else if (this.postStatus === 'F') {
            this.duplicateSSO = false;
            this.validateSSO = true;
          } else if (this.postStatus === 'IE') {
            this.isInEmailExist = false;

            this.validateSSO = true;
            this.invalidSSOAddNewIn = true;
            this.ValidateAgency = true;
            this.ValidateFirstName = true;
            this.ValidateLastName = true;
            this.ValidateRole = true;
            this.duplicateSSO = true;

          }
        }
        if (newUser.Usertype === this.externalUserType) {

          if (this.postStatus === 'P') {
            this.LoadExternalUsers();
            this.newExtenalUser = {};
            this.showAddExternalUserRow = false;
            this.restForm(myform);

            this.ValidateExFirstName = true;
            this.ValidateExLastName = true;
            this.ValidateExEmail = true;
            this.ValidateExAgency = true;
            this.isExEmailExist = true;
          } else if (this.postStatus === 'IE') {
            this.isExEmailExist = false;
          }
        }
      });
  }
  // Method to update Internal User Row
  onUpdateInternalRowClick(updatedInUserRow) {

    this.updatedINDetails = {};
    if (updatedInUserRow.agency === '') {
      delete updatedInUserRow.agency;
    }
    let bdata = this.beforIN;
    delete bdata.isEditable;
    delete updatedInUserRow.isEditable;
    updatedInUserRow.agency = this.selectedInAgency;
    updatedInUserRow.roles.roleID = this.selectedRole.roleID;
    updatedInUserRow.roles.roleName = this.selectedRole.roleName;
    if (JSON.stringify(bdata).toLowerCase() === JSON.stringify(updatedInUserRow).toLowerCase()) {
      if (this.msgs.length === 0) {
        this.msgs.push({ severity: 'info', summary: 'No Updates', detail: '' });
      }
    } else {
      this.msgs = [];
      this.invalidSSO = true;
      this.invalidInEditEmail = true;
      this.invalidInEditFirstName = true;
      this.invalidInEditLastName = true;
      updatedInUserRow.EmailID = updatedInUserRow.email;
      updatedInUserRow.UserRoleID = updatedInUserRow.roles.roleID;

      if (updatedInUserRow.agency !== '' && updatedInUserRow.agency != null) {
        updatedInUserRow.UserAgencyID = this.selectedInAgency.agencyID;
      }
      if (updatedInUserRow.agency === '') {
        updatedInUserRow.UserAgencyID = 0;
      }
      if (updatedInUserRow.agency == null) {
        updatedInUserRow.UserAgencyID = 0;
      }


      if (updatedInUserRow.sso !== bdata.sso) {
        this.updatedINDetails.sso = updatedInUserRow.sso;
      }
      if (updatedInUserRow.firstName !== bdata.firstName) {
        this.updatedINDetails.firstName = updatedInUserRow.firstName;
      }
      if (updatedInUserRow.lastName !== bdata.lastName) {
        this.updatedINDetails.lastName = updatedInUserRow.lastName;
      }
      if (updatedInUserRow.email !== bdata.email) {
        this.updatedINDetails.EmailID = updatedInUserRow.email;
      }
      if (updatedInUserRow.UserRoleID !== bdata.roles.roleID) {
        this.updatedINDetails.UserRoleID = updatedInUserRow.UserRoleID;
      }
      if (bdata.agency !== '') {
        if (bdata.agency != null) {
          if (updatedInUserRow.UserAgencyID !== bdata.agency.agencyID) {
            this.updatedINDetails.UserAgencyID = updatedInUserRow.UserAgencyID;
          }
        } else {
          this.updatedINDetails.UserAgencyID = updatedInUserRow.UserAgencyID;
        }
      }
      if (bdata.agency === '') {
        this.updatedINDetails.UserAgencyID = updatedInUserRow.UserAgencyID;
      }
      this.updatedINDetails.userID = <number>(updatedInUserRow.userID);
      this.updateUserDetails(this.updatedINDetails, this.internalUserType);

    }
    updatedInUserRow.isEditable = false;
    this.disableINeditBtn = false;
    this.disableINdeleteBtn = false;
  }
  // Method to update External User Row
  onUpdateExternalRowClick(updatedExUserRow) {

    this.updatedExDetails = {};
    if (updatedExUserRow.agency === '') {
      delete updatedExUserRow.agency;
    }

    let bdata = this.beforEx;
    delete bdata.isEditable;
    delete updatedExUserRow.isEditable;
    updatedExUserRow.agency = this.selectedExAgency;
    if (JSON.stringify(bdata).toLowerCase() === JSON.stringify(updatedExUserRow).toLowerCase()) {
      if (this.ExMsgs.length === 0) {
        this.ExMsgs.push({ severity: 'info', summary: 'No Updates', detail: '' });
      }
    } else {
      this.ExMsgs = [];
      this.invalidExEditEmail = true;
      this.invalidExEditFirstName = true;
      this.invalidExEditLastName = true;
      this.invalidExEditAgency = true;
      updatedExUserRow.EmailID = updatedExUserRow.email;
      if (updatedExUserRow.agency !== '') {
        updatedExUserRow.UserAgencyID = this.selectedExAgency.agencyID;
      }
      if (updatedExUserRow.agency === '') {
        updatedExUserRow.UserAgencyID = 0;
      }
      if (updatedExUserRow.firstName !== bdata.firstName) {
        this.updatedExDetails.firstName = updatedExUserRow.firstName;
      }
      if (updatedExUserRow.lastName !== bdata.lastName) {
        this.updatedExDetails.lastName = updatedExUserRow.lastName;
      }
      if (updatedExUserRow.email !== bdata.email) {
        this.updatedExDetails.EmailID = updatedExUserRow.email;
      }
      if (bdata.agency !== '') {
        if (updatedExUserRow.UserAgencyID !== bdata.agency.agencyID) {
          this.updatedExDetails.UserAgencyID = updatedExUserRow.UserAgencyID;
        }
      }
      if (bdata.agency === '') {
        this.updatedExDetails.UserAgencyID = updatedExUserRow.UserAgencyID;
      }
      this.updatedExDetails.userID = <number>(updatedExUserRow.userID);
      this.updatedExDetails.userAgencyMapID = <number>(updatedExUserRow.userAgencyMapID);

      this.updateUserDetails(this.updatedExDetails, this.externalUserType);
    }
    updatedExUserRow.isEditable = false;
    this.disableExEditBtn = false;
    this.disableExDeleteBtn = false;

  }
  // Method to update Internal/External User details
  updateUserDetails(updatedUserRow, userType) {
    // debugger;
    updatedUserRow.UpdatedDate = new Date();
    updatedUserRow.UpdatedBy = this.AuthManager.dynSSOId; // 500021256; //need to change
    this.adminService.updateUserDetails(updatedUserRow)
      .subscribe((status) => {
        this.postStatus = status;
        //console.log(this.postStatus);

        //console.log('Saved');
        if (this.postStatus !== 'AE') {
          if (userType === 'I') {
            this.LoadInternalUsers();
          }
          if (userType === 'E') {
            this.LoadExternalUsers();
          }

        } else {
          this.ValidateAgency = false;
          // this.disableExEditBtn = true;
          this.invalidExEditAgency = true;

          this.MultiAgencyExist = true;
        }



      });
  }
  //
  valuechange(newValue) {

    let newSSO = [];

    newSSO = newValue;
    let InternDetails: any[] = [];
    if (newSSO.length === 9 && newSSO !== [] && newSSO != null) {
      //console.log(newSSO);
    }

  }
  // Method to check whether the input fields of Internal user
  checkInFields(value) {

    if (value.sso === '' || value.firstName === '' || value.lastName === '' || value.email === ''
      || value.roles === '' || value.agency === '') {
      this.disableINUpdateBtn = true;

      this.msgs.push({ severity: 'error', summary: '', detail: 'Please fill all the fields!!' });
    }
    if (value.sso !== '' && value.firstName !== '' && value.lastName !== '' && value.email !== ''
      && value.roles !== '' && value.agency !== '') {
      this.msgs = [];
    }
  }

  // Method to check the SSO Field
  checkSSOField(value) {

    if (value.sso === '' || value.firstName === '' || value.lastName === '' || value.email === ''
      || value.roles === '' || value.agency === '') {
      this.disableINUpdateBtn = true;
      this.msgs = [];
      this.msgs.push({ severity: 'error', summary: '', detail: 'Please fill all the fields!!' });
    }
    if (value.sso === '') {

      this.disableINUpdateBtn = true;
      this.invalidSSO = false;
      this.duplicateSSOEditIN = true;
    }
    if (value.sso !== '') {
      if (value.sso.length !== 9) {
        this.disableINUpdateBtn = true;
        this.invalidSSO = false;
        this.duplicateSSOEditIN = true;

      }
    }
    if (value.sso !== '' && value.firstName !== '' && value.lastName !== '' && value.email !== ''
      && value.roles !== '' && value.agency !== '') {
      this.msgs = [];
    }
    if (!value.sso.match(this.ssoPattern)) {
      this.disableINUpdateBtn = true;
      this.invalidSSO = false;
    }
    if (value.sso.match(this.ssoPattern)) {
      if (value.sso.length === 9) {
        if (value.sso === 0) {
          this.disableINUpdateBtn = true;
          this.invalidSSO = false;
          this.duplicateSSOEditIN = true;
        } else {

          if (this.currentSSO === value.sso) {
            this.invalidSSO = true;
            this.duplicateSSOEditIN = true;

            if (value.sso !== '' && value.firstName !== '' && value.lastName !== '' && value.email !== ''
              && value.roles !== '' && value.agency !== '') {
              this.disableINUpdateBtn = false;
            }
          } else {
            this.invalidSSO = true;
            this.adminService.internalUserSearch(value.sso)
              .subscribe((status) => {
                this.SSOduplicateStatus = status;
                //console.log(this.SSOduplicateStatus);

                if (this.SSOduplicateStatus === 'F') {
                  this.duplicateSSOEditIN = false;
                  this.disableINUpdateBtn = true;
                }
                if (this.SSOduplicateStatus === 'P') {
                  this.duplicateSSOEditIN = true;

                  if (value.sso !== '' && value.firstName !== '' && value.lastName !== '' && value.email !== ''
                    && value.roles !== '' && value.agency !== '') {
                    this.disableINUpdateBtn = false;
                  }

                  if (this.invalidSSO === true && this.duplicateSSOEditIN === true && this.invalidInEditFirstName === true &&
                    this.invalidInEditLastName === true && this.invalidInEditEmail === true && this.duplicateEmailEditIN === true) {

                    this.disableINUpdateBtn = false;
                  } else {
                    this.disableINUpdateBtn = true;
                  }
                }
              });
          }
        }
      }
    }
  }

  // Method to check Internal user's Last Name
  checkInEmail(value) {


    if (value.sso === '' || value.firstName === '' || value.lastName === '' || value.email === ''
      || value.roles === '' || value.agency === '') {
      this.disableINUpdateBtn = true;
      this.msgs = [];
      this.msgs.push({ severity: 'error', summary: '', detail: 'Please fill all the fields!!' });
    }
    if (value.sso !== '' && value.firstName !== '' && value.lastName !== '' && value.email !== ''
      && value.roles !== '' && value.agency !== '') {
      this.msgs = [];
    }
    if (!value.email.match(this.internalEmailPattern)) {
      this.disableINUpdateBtn = true;
      this.invalidInEditEmail = false;
      this.duplicateEmailEditIN = true;
    }
    if (value.email.match(this.internalEmailPattern)) {

      if (this.currentEmail === value.email) {
        this.duplicateEmailEditIN = true;
        this.invalidInEditEmail = true;
        if (value.sso !== '' && value.firstName !== '' && value.lastName !== '' && value.email !== ''
          && value.roles !== '' && value.agency !== '') {
          this.disableINUpdateBtn = false;
        }

        if (this.invalidSSO === true && this.duplicateSSOEditIN === true && this.invalidInEditFirstName === true &&
          this.invalidInEditLastName === true && this.invalidInEditEmail === true && this.duplicateEmailEditIN === true) {

          this.disableINUpdateBtn = false;
        } else {
          this.disableINUpdateBtn = true;
        }
      } else {

        this.invalidInEditEmail = true;
        this.adminService.userEmailSearch(value.email)
          .subscribe((status) => {
            this.INduplicateEmailonEdit = status;
            //console.log(this.INduplicateEmailonEdit);

            if (this.INduplicateEmailonEdit === 'IE') {
              this.duplicateEmailEditIN = false;
              this.disableINUpdateBtn = true;
            }
            if (this.INduplicateEmailonEdit === 'P') {
              this.duplicateEmailEditIN = true;
              if (value.sso !== '' && value.firstName !== '' && value.lastName !== '' && value.email !== ''
                && value.roles !== '' && value.agency !== '') {
                this.disableINUpdateBtn = false;
              }
              if (this.invalidSSO === true && this.duplicateSSOEditIN === true && this.invalidInEditFirstName === true &&
                this.invalidInEditLastName === true && this.invalidInEditEmail === true && this.duplicateEmailEditIN === true) {

                this.disableINUpdateBtn = false;
              } else {
                this.disableINUpdateBtn = true;
              }
            }
          });
      }
    }

  }
  // Method to check Internal user's first name
  checkInFirstNameCheck(value) {

    if (value.firstName === '' || value.lastName === '' || value.email === '' || value.agency === '') {
      this.disableINUpdateBtn = true;
      this.msgs = [];
      this.msgs.push({ severity: 'error', summary: '', detail: 'Please fill all the fields!!' });
    }
    if (value.sso !== '' && value.firstName !== '' && value.lastName !== '' && value.email !== ''
      && value.roles !== '' && value.agency !== '') {
      this.msgs = [];
    }
    if (!value.firstName.match(this.namePattern)) {
      this.disableINUpdateBtn = true;
      this.invalidInEditFirstName = false;
    }
    if (value.firstName.match(this.namePattern) && value.firstName.trim().length > 0) {
      this.invalidInEditFirstName = true;
      if (value.sso !== '' && value.firstName !== '' && value.lastName !== '' && value.email !== ''
        && value.roles !== '' && value.agency !== '') {
        this.disableINUpdateBtn = false;
      }
      if (value.lastName !== '') {

        if (value.lastName.trim().length === 0) {
          this.disableINUpdateBtn = true;
          this.invalidInEditLastName = false;
        }
        if (!value.lastName.match(this.namePattern)) {
          this.disableINUpdateBtn = true;
          this.invalidInEditLastName = false;
        }
      }
      if (value.email !== '') {
        this.checkInEmail(value);
      }
      if (this.invalidSSO === true && this.duplicateSSOEditIN === true && this.invalidInEditFirstName === true &&
        this.invalidInEditLastName === true && this.invalidInEditEmail === true && this.duplicateEmailEditIN === true) {

        this.disableINUpdateBtn = false;
      } else {
        this.disableINUpdateBtn = true;
      }
    } else {
      this.disableINUpdateBtn = true;
      this.invalidInEditFirstName = false;
    }


  }
  // Method to check Internal user's last name
  checkInLastNameCheck(value) {

    if (value.firstName === '' || value.lastName === '' || value.email === '' || value.agency === '') {
      this.disableINUpdateBtn = true;
      this.msgs = [];
      this.msgs.push({ severity: 'error', summary: '', detail: 'Please fill all the fields!!' });
    }
    if (value.sso !== '' && value.firstName !== '' && value.lastName !== '' && value.email !== ''
      && value.roles !== '' && value.agency !== '') {
      this.msgs = [];
    }
    if (!value.lastName.match(this.namePattern)) {
      this.disableINUpdateBtn = true;
      this.invalidInEditLastName = false;
    }
    if (value.lastName.match(this.namePattern) && value.lastName.trim().length > 0) {
      this.invalidInEditLastName = true;
      if (value.sso !== '' && value.firstName !== '' && value.lastName !== '' && value.email !== ''
        && value.roles !== '' && value.agency !== '') {
        this.disableINUpdateBtn = false;
      }
      if (value.firstName !== '') {
        if (value.firstName.trim().length === 0) {
          this.disableINUpdateBtn = true;
          this.invalidInEditFirstName = false;
        }
        if (!value.firstName.match(this.namePattern)) {
          this.disableINUpdateBtn = true;
          this.invalidInEditFirstName = false;
        }
      }
      if (value.email !== '') {
        this.checkInEmail(value);
      }
      if (this.invalidSSO === true && this.duplicateSSOEditIN === true && this.invalidInEditFirstName === true &&
        this.invalidInEditLastName === true && this.invalidInEditEmail === true && this.duplicateEmailEditIN === true) {

        this.disableINUpdateBtn = false;
      } else {
        this.disableINUpdateBtn = true;
      }
    } else {
      this.disableINUpdateBtn = true;
      this.invalidInEditLastName = false;
    }

  }

  // Method to check whether the agency input field of internal user
  checkInAgency(value) {

    value.agency = this.selectedInAgency;
  }
  // Method to check whether the input fields of External user
  checkExFields(value) {

    if (value.firstName === '' || value.lastName === '' || value.email === '' || value.agency === '') {
      this.disableExUpdateBtn = true;
      this.ExMsgs = [];
      this.ExMsgs.push({ severity: 'error', summary: '', detail: 'Please fill all the fields!!' });
    }
    if (value.firstName !== '' && value.lastName !== '' && value.email !== '' && value.agency !== '') {
      this.disableExUpdateBtn = false;
      this.ExMsgs = [];
    }
  }

  // Method to check whether the agency input field of external user
  checkExAgency(value, agency) {
    if(!agency.agencyName){
      value.agency = this.selectedExAgency;
    }else{
      value.agency = this.selectedExAgency.agencyName;
    }

    //debugger;    
    if (value.agency === '') {
      this.invalidExEditAgency = false;
    }   
 
for (let i = 0; i < this.agency.length; i++) {
      if( value.agency != this.agency[i].agencyName ){
          this.invalidExEditAgency = false;
      }
      else {
        this.invalidExEditAgency = true;
        if (this.invalidExEditFirstName === true && this.invalidExEditLastName === true && this.invalidExEditEmail === true &&
          this.duplicateEmailEditEx === true && this.invalidExEditAgency === true) {
            this.disableExUpdateBtn = false;
        } else {
            this.disableExUpdateBtn = true;
        }
        return;
      }
    }


    if (this.invalidExEditFirstName === true && this.invalidExEditLastName === true && this.invalidExEditEmail === true &&
      this.duplicateEmailEditEx === true && this.invalidExEditAgency === true) {
      this.disableExUpdateBtn = false;
    } else {
      this.disableExUpdateBtn = true;
    }

    let requestData: any = {};
    requestData.agencyId = agency.agencyID;
    requestData.emailId = value.email;

    this.adminService.CheckExternalUserAgencyExist(requestData).subscribe((status) => {
      //debugger;
      this.duplicateExternalAgency = status;

      if (this.duplicateExternalAgency === 'Exist') {
        this.invalidExEditAgency = true;
        this.MultiAgencyExist = true;
        // this.disableExUpdateBtn = false;
        this.disableExEditBtn = true;
        this.disableExUpdateBtn = true;
      } else {
        this.MultiAgencyExist = false;

      }
    });

  }

  // External user agency check for adding

  checkAddExAgency(event, newUserEmail) {
    //debugger;
    if(event != null)
    {
      this.MultipleAgeccyID = event.agencyID;
    }

    this.AddMultiAgencyExist = false;

    let statusresult;

    let requestData: any = {};
    requestData.agencyId = this.MultipleAgeccyID;
    requestData.emailId = newUserEmail;

    this.adminService.CheckExternalUserAgencyExist(requestData).subscribe((status) => {
      //debugger;
      statusresult = status;

      if (statusresult === 'Exist') {
        this.AddMultiAgencyExist = true;
        this.ValidateExAgency = true;
      } else {
        this.AddMultiAgencyExist = false;
      }
    });

  }

  // Method to check External user's first name
  checkExFirstNameCheck(value) {

    if (value.firstName === '' || value.lastName === '' || value.email === '' || value.agency === '') {
      this.disableExUpdateBtn = true;
      this.ExMsgs = [];
      this.ExMsgs.push({ severity: 'error', summary: '', detail: 'Please fill all the fields!!' });
    }
    if (value.firstName !== '' && value.lastName !== '' && value.email !== '' && value.agency !== '') {
      this.disableExUpdateBtn = false;
      this.ExMsgs = [];
    }
    if (!value.firstName.match(this.namePattern)) {
      this.disableExUpdateBtn = true;
      this.invalidExEditFirstName = false;
    }
    if (value.firstName.match(this.namePattern) && value.firstName.trim().length > 0) {
      this.invalidExEditFirstName = true;
      if (value.firstName !== '' && value.lastName !== '' && value.email !== '' && value.agency !== '') {
        this.disableExUpdateBtn = false;
      }
      if (value.lastName !== '') {
        if (value.lastName.trim().length === 0) {
          this.disableExUpdateBtn = true;
          this.invalidExEditLastName = false;
        }
        if (!value.lastName.match(this.namePattern)) {
          this.disableExUpdateBtn = true;
          this.invalidExEditLastName = false;
        }
      }
      if (value.email !== '') {
        this.checkExEmail(value);
      }
      if (this.invalidExEditFirstName === true && this.invalidExEditLastName === true && this.invalidExEditEmail === true &&
        this.duplicateEmailEditEx === true && this.invalidExEditAgency === true) {

        this.disableExUpdateBtn = false;
      } else {
        this.disableExUpdateBtn = true;
      }
    } else {
      this.disableExUpdateBtn = true;
      this.invalidExEditFirstName = false;
    }

  }
  // Method to check External user's last name
  checkExLastNameCheck(value) {

    if (value.firstName === '' || value.lastName === '' || value.email === '' || value.agency === '') {
      this.disableExUpdateBtn = true;
      this.ExMsgs = [];
      this.ExMsgs.push({ severity: 'error', summary: '', detail: 'Please fill all the fields!!' });
    }
    if (value.firstName !== '' && value.lastName !== '' && value.email !== '' && value.agency !== '') {
      this.disableExUpdateBtn = false;
      this.ExMsgs = [];
    }
    if (!value.lastName.match(this.namePattern)) {
      this.disableExUpdateBtn = true;
      this.invalidExEditLastName = false;
    }
    if (value.lastName.match(this.namePattern) && value.lastName.trim().length > 0) {
      this.invalidExEditLastName = true;
      if (value.firstName !== '' && value.lastName !== '' && value.email !== '' && value.agency !== '') {
        this.disableExUpdateBtn = false;
      }
      if (value.firstName !== '') {
        if (value.firstName.trim().length === 0) {
          this.disableExUpdateBtn = true;
          this.invalidExEditFirstName = false;
        }
        if (!value.firstName.match(this.namePattern)) {
          this.disableExUpdateBtn = true;
          this.invalidExEditFirstName = false;
        }
      }
      if (value.email !== '') {
        this.checkExEmail(value);
      }
      if (this.invalidExEditFirstName === true && this.invalidExEditLastName === true && this.invalidExEditEmail === true &&
        this.duplicateEmailEditEx === true && this.invalidExEditAgency === true) {

        this.disableExUpdateBtn = false;
      } else {
        this.disableExUpdateBtn = true;
      }
    } else {
      this.disableExUpdateBtn = true;
      this.invalidExEditLastName = false;
    }

  }

  // Method to check whether the email field of External users
  checkExEmail(value) {

    if (value.firstName === '' || value.lastName === '' || value.email === '' || value.agency === '') {
      this.disableExUpdateBtn = true;
      this.ExMsgs = [];
      this.ExMsgs.push({ severity: 'error', summary: '', detail: 'Please fill all the fields!!' });
    }
    if (value.firstName !== '' && value.lastName !== '' && value.email !== '' && value.agency !== '') {
      this.disableExUpdateBtn = false;
      this.ExMsgs = [];
    }
    if (!value.email.match(this.emailPattern)) {
      this.disableExUpdateBtn = true;
      this.invalidExEditEmail = false;
      this.duplicateEmailEditEx = true;
    }
    if (value.email.match(this.emailPattern)) {

      if (this.currentExEmail === value.email) {
        this.invalidExEditEmail = true;
        this.duplicateEmailEditEx = true;
        if (value.firstName !== '' && value.lastName !== '' && value.email !== '' && value.agency !== '') {
          this.disableExUpdateBtn = false;
        }
        if (this.invalidExEditFirstName === true && this.invalidExEditLastName === true && this.invalidExEditEmail === true &&
          this.duplicateEmailEditEx === true && this.invalidExEditAgency === true) {

          this.disableExUpdateBtn = false;
        } else {
          this.disableExUpdateBtn = true;
        }
      } else {

        this.invalidExEditEmail = true;
        this.adminService.userEmailSearch(value.email)
          .subscribe((status) => {
            this.ExduplicateEmailonEditStatus = status;
            //console.log(this.ExduplicateEmailonEditStatus);

            if (this.ExduplicateEmailonEditStatus === 'IE') {
              this.duplicateEmailEditEx = false;
              this.disableExUpdateBtn = true;
            }
            if (this.ExduplicateEmailonEditStatus === 'P') {
              this.duplicateEmailEditEx = true;
              if (value.firstName !== '' && value.lastName !== '' && value.email !== '' && value.agency !== '') {
                this.disableExUpdateBtn = false;
              }
              if (this.invalidExEditFirstName === true && this.invalidExEditLastName === true && this.invalidExEditEmail === true &&
                this.duplicateEmailEditEx === true && this.invalidExEditAgency === true) {

                this.disableExUpdateBtn = false;
              } else {
                this.disableExUpdateBtn = true;
              }
            }
          });
      }
    }

  }
  // Method to delete internal users
  onRowINdeleteSelect(deletedInUserRow) {

    this.confirmationService.confirm({
      message: 'Do you want to delete this record?',
      header: 'Delete Confirmation',
      icon: 'fa fa-trash',
      accept: () => {
        this.deletedINuserDetails.userID = deletedInUserRow.userID;
        this.deletedINuserDetails.isActive = false;
        this.updateUserDetails(this.deletedINuserDetails, this.internalUserType);
      }
    });

  }
  // Method to delete External users
  onRowExternalDelete(deletedExUserRow) {

    this.confirmationService.confirm({
      message: 'Do you want to delete this record?',
      header: 'Delete Confirmation',
      icon: 'fa fa-trash',
      accept: () => {
        this.deletedINuserDetails.userID = deletedExUserRow.userID;
        this.deletedINuserDetails.isActive = false;
        this.deletedINuserDetails.userAgencyMapID = <number>(deletedExUserRow.userAgencyMapID);
        this.updateUserDetails(this.deletedINuserDetails, this.externalUserType);
      }
    });

  }

  // UserLog Details
  saveIP() {

    this.http.get<{ ip: string }>('https://jsonip.com')
      .subscribe(data => {
        this.LognewUser.IPAddress = data.ip;
        this.LognewUser.LoginTime = new Date();
        const { detect } = require('detect-browser');
        const browser = detect();
        this.LognewUser.Browsertype = browser.name;
        this.LognewUser.BrowserVersion = browser.version;
        this.LognewUser.SSO = this.AuthManager.dynSSOId;
        this.LognewUser.FirstName = this.AuthManager.dynFirstName;
        this.LognewUser.LastName = this.AuthManager.dynLastName;
        this.LognewUser.Active = 1;
        this.LognewUser.userID = sessionStorage.getItem('userid');
        this.adminService.searchUser(this.LognewUser.userID, this.LognewUser.IPAddress, this.LognewUser.Browsertype)
          .subscribe((logStatus) => {
            this.UserLogStatus = logStatus;
            if (this.UserLogStatus === 'Success') {

              this.adminService.LogNewUserDetails(this.LognewUser)
                .subscribe((newLogStatus) => { this.UserLogStatus = newLogStatus; });
            } else {
              this.LnewUser.IPAddress = this.LognewUser.IPAddress;
              this.LnewUser.Browsertype = this.LognewUser.Browsertype;
              this.LnewUser.LogOutTime = new Date();
              this.LnewUser.Active = 0;
              this.LnewUser.SSO = this.AuthManager.dynSSOId;
              this.LnewUser.userID = this.LognewUser.userID;
              this.adminService.LogUserUpdateDetails(this.LnewUser)
                .subscribe((updateLogStatus) => { this.UserLogStatus = updateLogStatus; });

              this.adminService.LogNewUserDetails(this.LognewUser)
                .subscribe((status) => { this.UserLogStatus = status; });
            }
          });
      }, error =>
          console.error(error));
  }

  // service call to get User Log Details in Excel
  GetUSerLog() {

    this.adminService.getLogUserDetails().subscribe(
      p => {
        this.LogUserDetails = p;
        let options = {
          fieldSeparator: ',',
          quoteStrings: '"',
          decimalseparator: '.',
          showLabels: true,
          showTitle: true,
          paddingCellOptions: this.paddingCells,
          title: 'MediaPay - User Log Details',
          useBom: true,
          noDownload: true,
          headers: ['SSO', 'First Name', 'Last Name', 'Agency ID', 'Login Time', 'Browser type', 'Browser Version', 'IP Address',
            'Logout Time', 'Active']
        };
        let UserLog = new Angular2Csv(p, 'User Log Details', options);
      });
    //console.log(this.LogUserDetails);
  }


  clearValue() {
    this.newInternalUser.newAgency = null;
  }
  clearExValue() {
    this.newExtenalUser.newExAgency = null;
    this.AddMultiAgencyExist = false;
    
  }
  // Method to filter data for Autocomplete starts
  agencyAutocompleteFilter(event) {

    let query = event.query;
    this.agencyFilter = this.filterAgency(query, this.agency);
  }

  filterAgency(query, resAgencyData): any[] {

    let filtered: any[] = [];
    query = query.toLowerCase();

    for (let i = 0; i < resAgencyData.length; i++) {
      let agencies = resAgencyData[i];

      if (agencies.agencyName.toLowerCase().indexOf(query) === 0 || agencies.agencyID.toString().toLowerCase().indexOf(query) === 0) {
        filtered.push(agencies);
      }
    }
    return filtered;
  }

  GetTransaction() {
    this.router.navigate(['TransactionRefund']);
  }
  //Arvind Add Agency
  GetAgency() {
    this.router.navigate(['agency']);
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/admin.component.ts